<template>
  <section class="section scEditAccount" :class="{open: show}">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="tree"></div>
      <div class="rightContentIn">
        <div class="header">
          <div class="backBtn" v-on:click="close"></div>
          <h4>Pengaturan akun</h4>
        </div>
        <div class="contentSc">
          <div class="menuCnt loading" v-if="loading">
            <div class="menuItem loading"></div>
          </div>
          <div class="menuCnt" v-else-if="user">
            <div class="menuItem" v-on:click="editUser('email', 'Alamat Email')">
              <div class="menuIcon about"></div>
              Email
              <span v-if="user.email">{{user.email}}</span>
              <span v-else>-</span>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="editUser('phone', 'No. Telp.')">
              <div class="menuIcon about"></div>
              No. Telp.
              <span v-if="user.phone">{{user.phone}}</span>
              <span v-else>-</span>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="editUser('username', 'Username')"
              v-if="1>2">
              <div class="menuIcon settings"></div>
              Username
              <span v-if="user.username">{{user.username}}</span>
              <span v-else>-</span>
              <div class="more"></div>
            </div>
            <div class="menuItem last" v-on:click="changePwd">
              <div class="menuIcon about"></div>
              Password
              <span>* * * * * *</span>
              <div class="more"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
    <MediaInputer2 ref="mediaInputer"/>
    <ChangePwd ref="changePwd"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import MediaInputer2 from '@/components/MediaInputer2.vue';
import ChangePwd from '@/components/ChangePwd.vue';

import config from '../config';

export default {
  name: 'home',
  components: {
    Confirmation,
    MediaInputer2,
    ChangePwd,
  },
  data() {
    return {
      aboNo: '. . .',
      user: null,
      avatar: null,
      loading: true,
      uploadUrl: '',
      uploadHeaders: {},
      show: false,
    };
  },
  created() {},
  destroyed() {},
  methods: {
    doNothing() {},
    open() {
      this.show = true;
      this.loading = true;
      this.getData();
    },
    close() { this.show = false; },
    getData() {
      this.avatar = this.$session.get('bk6_avatar');
      this.uploadUrl = this.$config.uri('user/avatar');
      this.uploadHeaders = {
        Key: config.apiKey,
        Authoziration: this.$session.get('bk6_jwt'),
      };
      this.$http.get(this.$config.uri('user/abo/number')).then((r) => {
        this.aboNo = (r.data.status === 200) ? r.data.data : 'Unknown';
      });
      this.$http.get(this.$config.uri('user/detail')).then((r) => {
        this.loading = false;
        this.user = (r.data.status === 200) ? r.data.data : null;
      });
    },
    editUser(field, title) {
      const type = (field === 'about') ? 'text' : 'input';
      this.$refs.mediaInputer.open({
        title,
        placeholder: title,
        type,
        action: 'Simpan',
        model: this.user[field],
      }, (v) => {
        this.$refs.mediaInputer.setLoading(true);
        this.$http.post(this.$config.uri(`user/set/${field}`), {
          value: v,
        }).then((r) => {
          this.$refs.mediaInputer.setLoading(false);
          if (r.data.status !== 200) {
            const msg = (r.data.message) ? r.data.message : 'Internal server error, please try again later';
            this.$refs.mediaInputer.setError(msg);
            return;
          }
          this.$refs.mediaInputer.close();
          this.user[field] = v;
        });
      });
    },
    changePwd() {
      this.$refs.changePwd.open();
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.section.scEditAccount{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    right: 0; top: 0; bottom: 0;
    background-color: #e6e1c1;

    background-color: #b7e4c9;
    background-image: linear-gradient(#fff 0, #e2fcec 50%, #fff);

    padding: 0 0 40px;
    box-sizing: border-box;
    width: 400px;
    z-index: 3;
    right: -400px;
    transition: all .45s ease;
    @media (max-width: 768px) {
      top: 60px;
    }
    @media (max-width: 680px) {
      width: 96%; right: -96%;
    }
    .tree{
      position: absolute;
      left: 0; right: -10px; bottom: 0; top: 0;
      background-image: url(../assets/high-five.png);
      background-size: auto 160px;
      background-position: right bottom;
      background-repeat: no-repeat;
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: #000;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      right: 0;
    }
  }
  .header{
    position: relative;
    padding: 5px 20px;
    z-index: 7;
    box-shadow: 0 0 4px rgba(0, 0, 0, .2);
    backdrop-filter: blur(20px);
    .backBtn{
      width: 40px; height: 40px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-next-black.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      font-size: 18px;
      margin: 0;
      color: #444;
      position: absolute;
      left: 80px; top: 13px; right: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .contentSc{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    overflow-y: auto;
    z-index: 5;
    padding: 65px 10px 10px;
  }
  .menuCnt{
    // padding: 20px 0 40px;
    margin: 0 0 60px;
    background-color: rgba(255, 255, 255, .5);
    position: relative;
    overflow: hidden;
    margin-bottom: -1px;
    @media (min-height: 680px) {
      margin-left: 10px;
      margin-right: 10px;
      border-radius: 10px;
    }
    &.loading{
      padding-top: 20px;
      background-color: transparent;
    }
    .aboNo{
      position: absolute;
      bottom: -26px; left: 20px;
      font-size: 13px;
      color: #767676;
    }
    .divider{
      height: 20px;
    }
    .menuItem{
      padding: 16px 20px;
      padding-right: 60px;
      font-weight: bold;
      color: #444;
      position: relative;
      margin: 0;
      font-size: 17px;
      transition: all .3s ease;
      cursor: pointer;
      background-color: rgba(255, 255, 255, .5);
      backdrop-filter: blur(20px);
      &:hover{
        background-color: rgba(255, 255, 255, .8);
      }
      &:before{
        position: absolute;
        content: "";
        height: 1px;
        left: 20px; right: 0; bottom: 0;
        background-color: #e5e5e5;
      }
      @media (min-height: 680px) {
        &.last:before{
          display: none;
        }
      }
      span{
        font-weight: normal;
        float: right;
      }
      &.loading{
        height: 54px;
        box-sizing: border-box;
        margin: 0;
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 46px auto;
        border: none;
        &:before{
          display: none;
        }
      }
      &:active{
        background-color: #ddd;
      }
      .more{
        position: absolute;
        right: 20px; top: 16px;
        width: 20px; height: 20px;
        background-position: center;
        background-size: 20px auto;
        background-repeat: no-repeat;
        background-image: url(../assets/edit-black.png);
      }
      &.logout{
        color: #fe3126;
      }
      .menuIcon{
        position: absolute;
        left: 20px; top: 16px;
        width: 20px; height: 20px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        opacity: .9;
        display: none;
        &.about{
          background-image: url(../assets/account.png);
        }
        &.settings{
          background-image: url(../assets/setting.png);
        }
        &.gallery{
          background-image: url(../assets/image-gallery.png);
        }
        &.link{
          background-image: url(../assets/foreign.png);
        }
        &.logout{
          background-image: url(../assets/logout-red.png);
        }
      }
    }
  }
}
</style>
